import axios from '../../lib/axios';
import { IComponentMaster, ILanguageMaster, IMenu, IStyleSettings, ITranslation, IUser, IUserGroups } from '../../models/account/accountModel';

const updateMenuList = (tree: any) => tree.map(({ data: { configMenuName: title, configMenuKey, configMenuURL }, children }: any) => ({
  title,
  configMenuKey,
  path: configMenuURL?.trim(),
  ...(children && { data: updateMenuList(children) })
}));

export const getMenus = async (configUserKey: string): Promise<any> => {
  const menuResponse = await axios.get<IMenu>(
    `ConfigAccount/GetAssignedMenu/${configUserKey}`
  );
  return updateMenuList(menuResponse?.data);
};

export const getStyleSettings = async (): Promise<any> => {
  const response = await axios.get<IStyleSettings[]>(
    '/InvestApp/GetStyleSettings'
  );
  return response?.data;
};

export const getConfigUserGroups = async (userEmail): Promise<any> => {
  const response = await axios.get<IUserGroups[]>(
    `/ConfigAccount/GetConfigUserGroups/${userEmail}`
  );
  return response?.data;
};

export const deleteConfigUserGroup = async (ConfigUserGroupKey): Promise<any> => {
  const response = await axios.post<IUserGroups>(
    `/ConfigAccount/DeleteConfigUserGroups/${ConfigUserGroupKey}`
  );
  return response?.data;
};

export const getConfigUsersList = async (userEmail): Promise<any> => {
  const response = await axios.get<IUser>(
    `/ConfigAccount/GetConfigUsersList/${userEmail}`
  );
  return response?.data;
};

export const getConfigUsersById = async (configUserKey): Promise<any> => {
  const response = await axios.get<IUser>(
    `/ConfigAccount/GetConfigUserByUserKey?configUserKey=${configUserKey}`
  );
  return response?.data;
};

export const addUpdateConfigUser = async (userData: IUser): Promise<any> => {
  const response = await axios.post<any>(
    'ConfigAccount/AddUpdateConfigUser', userData
  );
  return response?.data;
};

export const getLanguages = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/Language/GetLanguages'
  );
  return response?.data;
};

export const getLanguageByKey = async (languageKey): Promise<any> => {
  const response = await axios.get<any[]>(
    `/Language/GetLanguages?languageKey=${languageKey}`
  );
  return response?.data;
};

export const deleteLanguage = async (languageKey): Promise<any> => {
  const response = await axios.post<any>(
    `/Language/DeleteLanguage?languageKey=${languageKey}`
  );
  return response?.data;
};

export const AddUpdatelanguage = async (languageData): Promise<any> => {
  const response = await axios.post<any>(
    '/Language/AddUpdateLanguage', languageData
  );
  return response?.data;
};

export const getLanguageMaster = async (): Promise<any> => {
  const response = await axios.get<ILanguageMaster[]>(
    '/LanguageMaster/GetLanguageMaster'
  );
  return response?.data;
};

export const getCountryMaster = async (): Promise<any> => {
  const response = await axios.get<ILanguageMaster[]>(
    '/CountryMaster/GetCountryMaster'
  );
  return response?.data;
};

export const getTranslationByKey = async (translationKey): Promise<any> => {
  const response = await axios.get<ITranslation>(
    `/Translation/GetTranslations?translationKey=${translationKey}`
  );
  return response?.data;
};

export const deleteTranslation = async (translationKey): Promise<any> => {
  const response = await axios.post<ITranslation>(
    `/Translation/DeleteTranslation/${translationKey}`
  );
  return response?.data;
};

export const getComponentMaster = async (): Promise<any> => {
  const response = await axios.get<IComponentMaster[]>(
    '/Component/GetComponentMaster'
  );
  return response?.data;
};

export const AddTranslation = async (translationData: ITranslation): Promise<any> => {
  const response = await axios.post<any>(
    '/Translation/AddTranslation', translationData
  );
  return response?.data;
};

export const UpdateTranslation = async (data: any): Promise<any> => {
  const response = await axios.post<any>(
    '/Translation/UpdateTranslation', data
  );
  return response?.data;
};

export const getUserGroupMenus = async (configUserGroupKey: string): Promise<any> => {
  const menuResponse = await axios.get<IMenu>(
    `ConfigAccount/GetMenusForUserGroup/${configUserGroupKey}`
  );
  return menuResponse?.data;
};

export const getConfigUserRolePermissions = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    `/ConfigAccount/GetConfigUserRolePermissions`
  );
  return response.data;
};

export const getConfigUserGroupRoleWithPermissions = async (configUserGroupKey): Promise<any> => {
  const response = await axios.get<any[]>(
    `/ConfigAccount/GetConfigUserGroupRoleWithPermissions?ConfigUserGroupKey=${configUserGroupKey}`
  );
  return response.data;
};

export const getConfigUserGroupRoleWithPermission = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    `/ConfigAccount/GetConfigUserGroupRoleWithPermissions`
  );
  return response.data;
};

export const insertConfigUserGroupPermissionMapping = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/ConfigAccount/InsertConfigUserGroupPermissionMapping`,
    {
      configUserRolePermissionKey: data.configUserRolePermissionKey,
      configUserGroupKey: data.configUserGroupKey,
    }
  );
  return response.data;
};

export const updateConfigUserGroupPermissionMapping = async (
  data: any
): Promise<any> => {
  const response = await axios.post<any>(
    `/ConfigAccount/UpdateConfigUserGroupPermissionMapping`,
    {
      configUserRolePermissionKey: data.configUserRolePermissionKey,
      configUserGroupKey: data.configUserGroupKey,
    }
  );
  return response.data;
};

export const insertUpdateMenuAndSubMenu = async (data: any): Promise<any> => {
  // if (data.pages && data.pages.length > 0 && data.pages[0].pageFilter === null) {
  //   data.pages[0].pageFilter = [];
  // }
  const response = await axios.post<any>(
    `/MenuAndSubMenu/BulkInsertUpdateSubMenu`,
    data
  );
  return response.data;
};

export const getIcons = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    '/IconMaster/GetIconMaster'
  );
  return response?.data;
};

export const getPageGroupsAndPages = async (): Promise<any> => {
  const response = await axios.get<any[]>(
    `/MenuAndSubMenu/GetPageGroupsAndPages`
  );
  return response.data;
};

export const deletePageGroups = async (pageGroupKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageGroups/${pageGroupKey}`
  );
  return response?.data;
};

export const getPageGroupAndPageByKey = async (pageGroupKey): Promise<any> => {
  const response = await axios.get<any[]>(
    `/MenuAndSubMenu/GetPageGroupsAndPages?PageGroupKey=${pageGroupKey}`
  );
  return response.data;
};

export const deletePages = async (pageKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePages/${pageKey}`
  );
  return response?.data;
};

export const deletePageFilters = async (pageFilterKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageFilters/${pageFilterKey}`
  );
  return response?.data;
};

export const deletePageFilterValues = async (pageFilterValueKey): Promise<any> => {
  const response = await axios.post<any>(
    `/MenuAndSubMenu/DeletePageFilterValues/${pageFilterValueKey}`
  );
  return response?.data;
};

export const getUserGroups = async (userEmail): Promise<any> => {
  const response = await axios.get<any[]>(
    `/InvestApp/GetUserGroups/${userEmail}`
  );
  return response?.data;
};
